module.exports = __webpack_public_path__ + "img/monitoring-car-yellow.23a4a6db.svg";